var processInclude = require('base/util');

$(document).ready(function () {
    // Include base details
    processInclude(require('jquery-zoom'));
    processInclude(require('./product/detail'));
    processInclude(require('./einsteinCarousel'));

    // Gift Registry
    // try {
    //    processInclude(require('giftregistry/product/giftRegistry'));
    // } catch (ex) {
    // plugin not in use
    // }

    // Instore pickup
    // try {
    //    processInclude(require('instorepickup/product/pdpInstoreInventory'));
    // } catch (ex) {
    // plugin not in use
    // }

    try {
        processInclude(require('./product/recommendationQuickView'));
    } catch (ex) {
        console.log('Error at recommendation quickview script: ' + ex);
    }
});
